export const SALES_TEAM_MEMBER_PRODUCTS_PATH = '/sales_team_member/products'
export const SALES_TEAM_MEMBER_BANK_ACCOUNTS_PATH = '/sales_team_member/bank_accounts'
export const SALES_TEAM_MEMBER_NOTIFICATIONS_PATH = '/sales_team_member/notifications'
export const SALES_TEAM_MEMBER_DEALS_PATH = '/sales_team_member/deals'
export const SALES_TEAM_MEMBER_OPPORTUNITIES_PATH = '/sales_team_member/opportunities'
export const SALES_TEAM_MEMBER_DEAL_PATH = '/sales_team_member/deals/:id'
export const SALES_TEAM_MEMBER_DEAL_EDIT_PATH = '/sales_team_member/deals/edit/:id'
export const SALES_TEAM_MEMBER_RELOAD_PATH = '/sales_team_member*'
export const SALES_TEAM_MEMBER_NOT_FOUND_PATH = '*'
export const SALES_TEAM_MEMBER_OVERVIEW_PATH = '/sales_team_member'
export const SALES_TEAM_MEMBER_INVITES_PATH = '/sales_team_member/invites'
export const SALES_TEAM_MEMBER_TRANSFERS_PATH = '/sales_team_member/transfers'
export const SALES_TEAM_MEMBER_PROFILE_PATH = '/sales_team_member/profile/edit'
export const SALES_TEAM_MEMBER_SUPPORT_PATH = '/sales_team_member/support'
export const SALES_TEAM_MEMBER_PAYOUTS_PATH = '/sales_team_member/payouts'
export const SALES_TEAM_MEMBER_PARTNER_PATH = '/sales_team_member/partner'
export const SALES_TEAM_MEMBER_ONBOARDING_PATH = '/sales_team_member/onboarding_journey'
export const SALES_TEAM_MEMBER_ONBOARDING_BUSINESS_PATH = '/sales_team_member/onboarding_journey/business_information'
export const SALES_TEAM_MEMBER_ONBOARDING_VERIFICATION_PATH = '/sales_team_member/onboarding_journey/verification'
export const SALES_TEAM_MEMBER_ONBOARDING_PAYOUT_PATH = '/sales_team_member/onboarding_journey/payout_details'
